import React, {useCallback, useMemo} from 'react';
import styles from './index.module.scss';

import face from '../../../assets/icons/face_id_square.svg'
import check from '../../../assets/icons/check_circle_broken.svg'
import hand from '../../../assets/icons/coins_hand.svg'
import file from '../../../assets/icons/file_shield_02.svg'
import Button from "../Button";
import Link from "../../CustomLink";
import {analyticsHandler} from "../../../helpers/utils";

interface Props {
  title?: string
}

const Features = ({title = 'Shopping tools'}: Props) => {
  const tools = useMemo(() => {
    return [
      {
        icon: face,
        subtitle: 'AI Chat Bot',
        text: `Our AI-powered chatbot offers a 24/7 personalized car buying assistant, 
        to answer your queries and guide you to your ideal vehicle.`,
        link: 'https://form.typeform.com/to/rg66JsYy?utm_source=xxxxx&utm_medium=xxxxx&utm_campaign=xxxxx&utm_term=xxxxx&utm_content=xxxxx',
        target: '_blank'
      },
      {
        icon: check,
        subtitle: 'Get Competitive Offers',
        text: `Discover the best deals and offers on cars across our expansive inventory, 
        ensuring you always get value for your money.`,
        link: '/check_availability'
      },
      {
        icon: file,
        subtitle: 'Insurance Marketplace ',
        text: `Navigate the world of car insurance with ease, 
        as we connect you to a diverse marketplace of trusted providers and competitive rates.`,
        link: '/insurance'
      },
      {
        icon: hand,
        subtitle: 'Trade-In',
        text: `Unlock the true value of your car with ease! Compare offers, choose the best, and get paid easily.`,
        link: '/sell'
      },
    ]
  }, []);
  const handleClick = useCallback((sectionName: string) => {
    analyticsHandler('shopping-tools', {"custom_event_name": sectionName})
  }, [])
  return (
    <section className={styles.root} aria-label={'Shopping tools'}>
      <p className={styles.title}>{title}</p>

      <div className={styles.wrapper}>
        {tools.map((item, i) => {
          return (
            <div key={i} className={styles.item}>
              <div className={styles.imgContainer}>
                <img src={item.icon} alt={item.subtitle} />
              </div>
              <p className={styles.subtitle}>{item.subtitle}</p>
              <p className={styles.text}>{item.text}</p>
              <Link to={item.link || ''} className={styles.buttonWrapper} target={item.target}>
                <Button text='Continue' className={styles.button} onClick={handleClick.bind(null, item.subtitle)} />
              </Link>
            </div>
          )
        })}
      </div>
    </section>
  )
}

export default React.memo(Features)
